"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const reducer_1 = __importDefault(require("../exportedStore/loader/reducer"));
const reducer_2 = __importDefault(require("../exportedStore/modals/reducer"));
const reducer_3 = __importDefault(require("../exportedStore/auth/reducer"));
const reducer_4 = require("../exportedStore/clients/reducer");
const reducer_5 = __importDefault(require("./stat/reducer"));
const reducer_6 = __importDefault(require("./users/reducer"));
const reducer_7 = __importDefault(require("./tours/reducer"));
exports.store = (0, toolkit_1.configureStore)({
    reducer: (0, toolkit_1.combineReducers)({
        authReducer: reducer_3.default,
        loaderReducer: reducer_1.default,
        modalsReducer: reducer_2.default,
        clientsReducer: reducer_4.clientsReducer,
        usersReducer: reducer_6.default,
        statReducer: reducer_5.default,
        toursReducer: reducer_7.default,
    }),
});
